import Vue from 'vue'
import Vuex from 'vuex'

import contentful from './modules/contentful'
import wishlist from './modules/wishlist'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    contentful,
    wishlist
  },
  state: {
    lang: undefined,
    touch: false,
    contentfulLangMap: {
      it: 'it',
      en: 'en-US'
    }
  },
  plugins: [createPersistedState()],
  getters: {
    touch: state => state.touch,
    lang: state => state.lang
  },
  mutations: {
    changeLanguage (state, lang) {
      state.lang = lang
    },
    setTouch (state) {
      state.touch = true
    }
  }
})
